export default __webpack_public_path__ + "static/media/Logo_QFX.3d69dd82.png";